"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieceRegistry = void 0;
class PieceRegistry {
    constructor() {
        this.listeners = new Set();
        this.version = 0;
        this.rafScheduled = false;
        this.pendingNotify = false;
        this.subscribe = (listener) => {
            this.listeners.add(listener);
            return () => this.listeners.delete(listener);
        };
        this.getSnapshot = () => this.version;
        this.pieces = new Map();
    }
    registerPiece(piece) {
        this.pieces.set(piece.id, piece);
        this.markChanged();
    }
    deregisterPiece(pieceId) {
        this.pieces.delete(pieceId);
        this.markChanged();
    }
    getPieceById(pieceId) {
        return this.pieces.get(pieceId) || null;
    }
    markChanged(opts) {
        var _a;
        this.version++;
        const immediate = (_a = opts === null || opts === void 0 ? void 0 : opts.immediate) !== null && _a !== void 0 ? _a : false;
        // coalesce to the next animation frame to avoid excessive renders
        const shouldCoalesce = !immediate &&
            typeof window !== "undefined" &&
            typeof requestAnimationFrame !== "undefined";
        if (!shouldCoalesce) {
            this.notifyListeners();
            return;
        }
        this.pendingNotify = true;
        if (this.rafScheduled) {
            return;
        }
        this.rafScheduled = true;
        requestAnimationFrame(() => {
            this.rafScheduled = false;
            if (!this.pendingNotify) {
                return;
            }
            this.pendingNotify = false;
            this.notifyListeners();
        });
    }
    notifyListeners() {
        for (const l of this.listeners) {
            l();
        }
    }
}
exports.PieceRegistry = PieceRegistry;
